// extracted by mini-css-extract-plugin
export default {"Subscribe":"ProductHubSubscribe_Subscribe__9Kt8m"};